import React, { useRef, useState, useEffect } from "react";

import { ThirdPartyCall, ThirdPartyMail, ThirdPartyIcon, AssignedThirdIcon, AssignedDateIcon, LeftOutlinedIcon, RightOutlinedIcon, TruckImgIcon } from "./assets/svgExport";

import { TopWrapper } from "./ThirdPartyStyles";
import { Empty } from "antd";
import { displayValueOrNA, formatDate, formatDateTime } from "./assets/utils";

interface DataCardProps {
  icon: React.ReactNode;
  title: string;
  value: string;
}

const AssignTop = ({ fetchedData, data }: { fetchedData: any; data: any }) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const files = data?.data ?? [];
  const details = fetchedData?.data?.[0];
  const imageList = files;

  const updateScrollButtons = () => {
    if (!scrollRef.current) return;

    const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;

    setCanScrollLeft(scrollLeft > 0);
    setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 5);
  };

  const scrollImages = (direction: "left" | "right") => {
    if (!scrollRef.current) return;

    const imageWidth = 424 + 12;

    scrollRef.current.scrollBy({
      left: direction === "left" ? -imageWidth : imageWidth,
      behavior: "smooth",
    });

    setTimeout(updateScrollButtons, 300);
  };

  useEffect(() => {
    updateScrollButtons();
  }, [imageList]);

  const DataCard: React.FC<DataCardProps> = ({ icon, title, value }) => (
    <div className="data-card">
      <div className="icon">{icon}</div>
      <span>
        <h1>{title}</h1>
        <h2>{value}</h2>
      </span>
    </div>
  );

  return (
    <TopWrapper>
      <div className="top-header">
        <div className="logo">
          <ThirdPartyIcon />
        </div>

        <div className="contact-info">
          <div className="contact-item">
            <ThirdPartyCall />
            <span>{details?.vehicle_defect_resolution?.[0]?.workshop?.phone_number}</span>
          </div>
          <div className="contact-item">
            <ThirdPartyMail />
            <span>{details?.vehicle_defect_resolution?.[0]?.workshop?.email_id}</span>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="contentWrapper">
          <h1>
            {details?.damage_type?.category}-<span>{details?.damage_type?.sub_category}</span>
          </h1>
          <h2>
            <span className="icon">
              <TruckImgIcon />
            </span>
            {details?.registration_number}
          </h2>
        </div>

        <div className="cardWrapper">
          <DataCard icon={<AssignedThirdIcon />} title="Assigned Date & Time" value={displayValueOrNA(formatDateTime(details?.created_at))} />
          <DataCard icon={<AssignedDateIcon />} title="Required by Date" value={displayValueOrNA(formatDate(details?.vehicle_defect_resolution?.[0]?.required_by))} />
          <DataCard icon={<AssignedDateIcon />} title="Booking Date" value={displayValueOrNA(formatDate(details?.vehicle_defect_resolution?.[0]?.drop_off_date))} />
        </div>

        <div className="imgWrapper">
          <button
            className="scroll-btn left"
            disabled={!canScrollLeft}
            onClick={() => scrollImages("left")}
            style={{
              opacity: canScrollLeft ? 1 : 0.3,
              pointerEvents: canScrollLeft ? "auto" : "none",
            }}
          >
            <LeftOutlinedIcon />
          </button>

          <div className="carousel-container" ref={scrollRef}>
            {Array.isArray(imageList) && imageList.length > 0 ? (
              imageList.map((file: any, index: number) => <img key={index} src={file.url} alt={file.file_name || `Image ${index + 1}`} className="carousel-image" />)
            ) : (
              <div className="empty-state">
                <Empty description="No data available" />
              </div>
            )}
          </div>

          <button
            className="scroll-btn right"
            disabled={!canScrollRight}
            onClick={() => scrollImages("right")}
            style={{
              opacity: canScrollRight ? 1 : 0.3,
              pointerEvents: canScrollRight ? "auto" : "none",
              cursor: canScrollRight ? "auto" : "not-allowed",
            }}
          >
            <RightOutlinedIcon />
          </button>
        </div>
      </div>
    </TopWrapper>
  );
};

export default AssignTop;
